import React from 'react'
import zuImg from '@/assets/images/nodata.png'
import './index.scss'
const NoMember = () => {
    return (
        <div className='no-member__box'>
            <img src={zuImg} alt="" />
            <span>您的车队还没有队员，点击下方按钮邀请队员</span>
        </div>
    )
}
export default NoMember
